import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters'

import user from './modules/user'
import tabs from './modules/tabs'
import order from './modules/order'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        user,
        tabs,
        order
    },
    getters
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js